import { createContext, useContext } from "react";

const MobileContext = createContext(document.body.offsetWidth < 799);

const MobileProvider = ({ children, isMobile }) => {
  return (
    <MobileContext.Provider value={isMobile}>{children}</MobileContext.Provider>
  );
};

const useMobile = () => {
  return useContext(MobileContext);
};

export { MobileProvider, useMobile };
